import script from "./WordsDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./WordsDetails.vue?vue&type=script&setup=true&lang=js"

import "./WordsDetails.vue?vue&type=style&index=0&id=1dbcc7a5&lang=scss"
import "./WordsDetails.vue?vue&type=style&index=1&id=1dbcc7a5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dbcc7a5"]])

export default __exports__